// Zieht die Aufgaben eines Schuelers fuer seine Sitzung — einmal, beim ersten
// Oeffnen. Jeder Schueler zieht selbst; verglichen wird in der Lehreransicht
// ueber die Kategorien, nicht ueber einzelne Aufgaben.

import { tasks } from '@/data/Tasks'
import { inventar, schemata } from '@/data/daten'
import { uebungsarten, passt } from '@/data/Uebungsarten'
import { baueUebung, mische } from './Uebung'
import { bereiteVor } from './Fehler'

function leererEintrag(aufgabe, typ, kategorien) {
    return { aufgabe, typ, kategorien, pruefungen: 0, ergebnis: 'offen' }
}

// Reihum: jeder Durchgang mischt alle einmal, so lange bis "anzahl" erreicht
// ist. So kommt jedes Element etwa gleich oft vor.
function reihum(liste, anzahl) {
    let reihe = []
    while (reihe.length < anzahl) reihe = reihe.concat(mische(liste))
    return reihe.slice(0, anzahl)
}

// Funkaufgaben: Zufallsauswahl aus den gewaehlten Kategorien (leer = alle).
// Gemerkt wird das Label — es ist eindeutig und genuegt, um die Aufgabe
// nach einem Neuladen wiederzufinden.
export function ziehenFunk(konfiguration) {
    const { kategorien, anzahl } = konfiguration
    const passend = kategorien.length === 0
        ? tasks
        : tasks.filter(t => t.categories.some(c => kategorien.includes(c)))
    const gezogen = mische(passend).slice(0, anzahl)
    return {
        aufgaben: gezogen.map(t => t.label),
        stand: gezogen.map(t => leererEintrag(t.label, 'funk', t.categories))
    }
}

// Sprechregeln: die Uebungen werden erzeugt, nicht ausgewaehlt. Ganze Uebungen
// werden gemerkt, damit ein Neuladen dieselben Saetze zeigt.
// Kategorien sind die Namen der Ablaeufe, Uebungsarten deren ids (beide:
// leer = alle). Zuerst werden die Uebungsarten reihum verteilt, dann bekommt
// jeder Platz einen Ablauf, der zu seiner Art passt (passt() — "Einfach
// sortieren" geht nur mit abwechselnden Ablaeufen). Die passenden Ablaeufe
// jeder Art kommen ebenfalls reihum dran.
// Arten ohne passenden Ablauf fallen weg. Das Lehrerformular laesst eine
// solche Wahl gar nicht zu; bleibt trotzdem keine Art uebrig, gelten alle,
// die gehen ("Alles sortieren" geht immer).
// bereiteVor wuerfelt die Fehler (und bei "Reagieren" Rolle und Stoerung)
// gleich mit; sie werden mit der Uebung gemerkt, damit ein Neuladen dieselben
// zeigt. Die Rolle waehlt der Ausbildner (konfiguration.rolle, fehlt = zufall).
export function ziehenSprechregeln(konfiguration) {
    const { kategorien, anzahl } = konfiguration
    const gewaehlteArten = konfiguration.uebungsarten ?? []
    const passend = kategorien.length === 0
        ? schemata
        : schemata.filter(s => kategorien.includes(s.name))
    const moeglich = (arten) => arten.filter(a => passend.some(s => passt(a.id, s)))
    let arten = moeglich(gewaehlteArten.length === 0
        ? uebungsarten
        : uebungsarten.filter(a => gewaehlteArten.includes(a.id)))
    if (arten.length === 0) arten = moeglich(uebungsarten)

    const artenReihe = reihum(arten, anzahl)
    const ablaeufe = {}   // pro Art die noch nicht gezogenen passenden Ablaeufe
    const gezogen = artenReihe.map(a => {
        if (!ablaeufe[a.id]?.length) ablaeufe[a.id] = mische(passend.filter(s => passt(a.id, s)))
        return ablaeufe[a.id].pop()
    })
    return {
        aufgaben: gezogen.map((s, i) => bereiteVor(artenReihe[i].id, baueUebung(s, inventar), konfiguration.rolle)),
        stand: gezogen.map((s, i) => ({
            ...leererEintrag(`sr-${i + 1}`, 'sprechregeln', [s.name]),
            art: artenReihe[i].id
        }))
    }
}
